module.exports = __webpack_public_path__ + "static/media/close-white.9a971803.svg";